import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: string;
};

export const updateUser = withLogger(async (payload): Promise<Response> => {
  const url = userSettingsAPIUrls.save;

  const { data } = await authServiceAxiosClient.post<Response>(url, payload);

  return data;
});
